import styled from 'styled-components';

import MenuItem from '../layout/Menu/MenuItem';

export type VirtualizedMenuItemProps = {
  start: number;
  height: number;
};

const VirtualizedMenuItem = styled(MenuItem).attrs<VirtualizedMenuItemProps>(
  (props) => ({
    style: {
      transform: `translateY(${props.start}px)`,
      height: `${props.height}px`,
    },
  }),
)<VirtualizedMenuItemProps>`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
`;

VirtualizedMenuItem.displayName = 'VirtualizedMenuItem';

export default VirtualizedMenuItem;
